export function formatComponentName (vm) {
  if (vm.$root === vm) {
    return 'root instance'
  }
  const name = vm._isVue ? vm.$options.name || vm.$options._componentTag : vm.name
  return name
}

export function copyHrefToClipboard (idSelector) {
  const input = document.getElementById('clipboardInput')
  input.type = 'text'
  input.value = document.getElementById(idSelector).href
  input.select()
  return document.execCommand('copy')
}

export function getDateStringDdMmYyyy (date, separator = '/') {
  /*
   * Returns a formatted date string dd/mm/yyyy.
   */
  return ('0' + date.getDate()).slice(-2) + separator + ('0' + (date.getMonth() + 1)).slice(-2) + separator + date.getFullYear()
}

export function getDateStringYyyyMmDd (date, separator = '/') {
  /*
   * Returns a formatted date string yyyy//mm/dd.
   */
  return date.getFullYear() + separator + ('0' + (date.getMonth() + 1)).slice(-2) + separator + ('0' + date.getDate()).slice(-2)
}
